import { render, staticRenderFns } from "./CustomerInspection.vue?vue&type=template&id=35c9a72e&scoped=true&"
import script from "./CustomerInspection.vue?vue&type=script&lang=js&"
export * from "./CustomerInspection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInspection.vue?vue&type=style&index=0&id=35c9a72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9a72e",
  null
  
)

export default component.exports